const videoBannerSectins = document.querySelectorAll('.video-banner-section.video-hosted');

videoBannerSectins.forEach(section => {
  const playButton = section.querySelector('.play-button-c');
  const video = section.querySelector('video');

  playButton.addEventListener('click', () => {
    video.play();

    setTimeout(() => {
      section.classList.add('show-video');
    }, 30);
  })
});